import { generatePath, Link } from 'react-router-dom';
import Tooltip from '@components/Tooltip';
import type { LibraryBlockTypeForListPage } from '@ContractBuilder/types';
import type { BaseUser } from '@root/@types/types';
import { isSuperadmin } from '@root/helpers/permissions';
import type Nav from '@root/src/routes';
import sharedClasses from '@root/src/utils/shared-classes';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';
import clsx from 'clsx';

export const editDisplay = <T extends LibraryBlockTypeForListPage>(
  columnHelper: ColumnHelper<T>,
  path: Nav.Block | Nav.Clause,
  user?: BaseUser | null,
) =>
  columnHelper.display({
    id: 'edit',
    enableColumnFilter: false,
    enableHiding: false,
    size: 65,
    minSize: 65,
    maxSize: 65,
    cell: (cellContext: CellContext<T, unknown>) => {
      const { canEditOnTemplate, id } = cellContext.row.original;
      const isUserSuperAdmin = user && isSuperadmin(user);

      const isDisabled = !canEditOnTemplate && !isUserSuperAdmin;
      return (
        <Tooltip content="This block can only by edited by a superadmin" disabled={!isDisabled}>
          <div className="flex items-center justify-center">
            <Link
              className={clsx(
                'text-primary-600 hover:text-primary-900 cursor-pointer truncate font-light transition-colors disabled:cursor-not-allowed disabled:opacity-50',
                isDisabled && sharedClasses.disabled,
              )}
              aria-disabled={isDisabled}
              to={generatePath(path, { id })}
              rel="noreferrer"
            >
              Edit
            </Link>
          </div>
        </Tooltip>
      );
    },
    meta: {
      dataCellClassName: 'relative truncate whitespace-nowrap px-1 py-0 text-center text-sm font-medium',
    },
  });
